export default {
  'magazine:breadcrumb:magazine': 'Magazine',
  'magazine:top-page:title': 'Pets Deli Magazine',
  'magazine:top-page:subtitle':
    'Discover our topics related to the nutrition, health, and training of dogs and cats.',
  'magazine:top-page:in-focus': 'Current Topics',
  'magazine:top-page:main-theme': 'Popular Categories',
  'magazine:top-page:top-articles': 'Our Articles',
  'magazine:author-page:title': 'Latest articles by {name}',
  'magazine:article-page:section-cta:default-title': 'Read also',
  'magazine:article-page:table-of-contents': 'Table of Contents',
};
